// Constants
const KCC_RESULT_CONTEXT_KEY_SEP = '__'


const getKccResultContextKey = ({ color, system, surface, survey, primers, reti, rasanti, is_tintometer }) => {
  return [
    color,
    system,
    surface,
    survey ?? 'NOSURV',
    !!primers?.length ? primers.join('-') : 'NOPRIMERS',
    !!reti?.length ? reti.join('-') : 'NORETI',
    !!rasanti?.length ? rasanti.join('-') : 'NORASANTI',
    is_tintometer ? 'T' : 'P'
  ].join(KCC_RESULT_CONTEXT_KEY_SEP);
}

export default getKccResultContextKey;